import { render, staticRenderFns } from "./ModalUserNameEdit.vue?vue&type=template&id=6bc2b22a&scoped=true&lang=pug&"
import script from "./ModalUserNameEdit.vue?vue&type=script&lang=ts&"
export * from "./ModalUserNameEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUserNameEdit.vue?vue&type=style&index=0&id=6bc2b22a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2b22a",
  null
  
)

export default component.exports